var _cardTypeToParserMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import uniqueId from 'lodash/uniqueId';
import divCardParser from './div-cards/parser';
import textCardParser from './text-card-parser';
import { sumWeight, getTextWeight } from './util';
import { CARD_TYPES, MESSAGE_TYPE, MESSAGE_FROM, WEIGHT } from './const';

var cardTypeToParserMap = (_cardTypeToParserMap = {}, _defineProperty(_cardTypeToParserMap, CARD_TYPES.text, textCardParser), _defineProperty(_cardTypeToParserMap, CARD_TYPES.textWithButton, textCardParser), _defineProperty(_cardTypeToParserMap, CARD_TYPES.div, divCardParser), _cardTypeToParserMap);

/**
 * Фабрика сообщения от асистента
 * @param  {Strign} options.text
 * @return {Object}
 */
export var assistantMessage = function assistantMessage(response) {
    if (!response) {
        return null;
    }

    var cards = (response.cards || []).map(cardFactory).filter(Boolean);

    return {
        from: MESSAGE_FROM.assistant,
        type: MESSAGE_TYPE.rich,
        cards: cards,
        id: uniqueId('assistantMessage_'),
        weight: sumWeight(cards)
    };
};

/**
 * Фабрика сообщения пользователя
 * @param  {Object} options.text
 * @return {Object}
 */
export var userMessage = function userMessage() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$id = _ref.id,
        id = _ref$id === undefined ? '' : _ref$id,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? '' : _ref$text;

    if (!text) {
        return null;
    }

    var userText = String(text);
    var weight = WEIGHT.bubble + getTextWeight(userText);

    return {
        from: MESSAGE_FROM.user,
        type: MESSAGE_TYPE.text,
        text: userText,
        id: id || uniqueId('message_'),
        weight: weight
    };
};

/**
 * Фабрика сообщения команды
 * @param  {Object} config
 * @return {Object}
 */
export var commandMessage = function commandMessage() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        from: MESSAGE_FROM.assistant,
        type: MESSAGE_TYPE.command,
        id: uniqueId('commandMessage_'),
        config: config,
        weight: 3
    };
};

/**
 * Фабрика сообщения от пользователя
 * @param  {String} options.text
 * @param  {Boolean} options.isFinal
 * @param  {Boolean} options.isPrompt
 * @return {Object}
 */
export var listeningMessage = function listeningMessage() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$id = _ref2.id,
        id = _ref2$id === undefined ? '' : _ref2$id,
        _ref2$text = _ref2.text,
        text = _ref2$text === undefined ? '' : _ref2$text;

    return {
        from: MESSAGE_FROM.user,
        type: MESSAGE_TYPE.listening,
        text: text,
        textParts: text.split(' '),
        id: id || uniqueId('listening_'),
        weight: 0
    };
};

/**
 * Фабрика карточки
 * @param  {Object} card
 * @return {Object}
 */
var cardFactory = function cardFactory(card) {
    if (!card) {
        return null;
    }

    var parser = cardTypeToParserMap[card.type];

    return parser ? parser(card) : null;
};